import BUY_IT_AGAIN_CONSTANTS from './BuyItAgain.constants';

export const getBuyItAgainProducts = (userEmail) => ({
  type: BUY_IT_AGAIN_CONSTANTS.BUY_IT_AGAIN_PRODUCTS_START,
  payload: userEmail,
});

export const buyItAgainProductsSuccess = (payload) => ({
  type: BUY_IT_AGAIN_CONSTANTS.BUY_IT_AGAIN_PRODUCTS_SUCCESS,
  payload,
});

export const fetchBiaPageProducts = (payload) => ({
  type: BUY_IT_AGAIN_CONSTANTS.FETCH_BIA_PAGE_PRODUCTS,
  payload,
});

export const getMoreProducts = (payload) => ({
  type: BUY_IT_AGAIN_CONSTANTS.GET_MORE_BIA_PRODUCTS,
  payload,
});

export const setInitialProductsLoaded = (payload) => ({
  type: BUY_IT_AGAIN_CONSTANTS.SET_INITIAL_PRODUCTS_LOADED,
  payload,
});

export const setBiaPageProducts = (payload) => ({
  type: BUY_IT_AGAIN_CONSTANTS.SET_BIA_PAGE_PRODUCTS,
  payload,
});

export const setBiaIsLoadingMore = (payload) => ({
  type: BUY_IT_AGAIN_CONSTANTS.SET_BIA_IS_LOADING_MORE,
  payload,
});

export const setBiaTotalProductsCount = (payload) => ({
  type: BUY_IT_AGAIN_CONSTANTS.SET_BIA_TOTAL_PRODUCTS_COUNT,
  payload,
});

export const clearBiaCache = () => ({
  type: BUY_IT_AGAIN_CONSTANTS.CLEAR_BIA_CACHE,
});
export const resetBIA = () => ({
  type: BUY_IT_AGAIN_CONSTANTS.RESET_BIA,
});

export const buyItAgainFailure = () => ({
  type: BUY_IT_AGAIN_CONSTANTS.BUY_IT_AGAIN_PRODUCTS_FAILURE,
});

export const toggleBIALoader = (payload) => ({
  type: BUY_IT_AGAIN_CONSTANTS.SET_BIA_LOADING,
  payload,
});

export const toggleBIAPageLoader = (payload) => ({
  type: BUY_IT_AGAIN_CONSTANTS.SET_BIA_PAGE_LOADING,
  payload,
});
export const setCD66 = (payload) => {
  return {
    type: BUY_IT_AGAIN_CONSTANTS.SET_CD66,
    payload,
  };
};

export const clearCD66 = () => {
  return {
    type: BUY_IT_AGAIN_CONSTANTS.CLEAR_CD66,
  };
};

export const setBiaInitialApiActualProductCount = (payload) => ({
  type: BUY_IT_AGAIN_CONSTANTS.SET_BIA_INITIAL_API_ACTUAL_PRODUCTS_COUNT,
  payload,
});

export const setBiaResponse = (payload) => ({
  type: BUY_IT_AGAIN_CONSTANTS.SET_BIA_API_RESPONSE,
  payload,
});
